export type SnapshotValues = { [key: string]: string };

/**
 * Collect current form field values from a container of injected HTML using `data-id` or `data-field-id`.
 * - Inputs: checkbox -> 'true'/'false', radio -> captures checked radio's value, others -> string value
 * - Textarea/select -> string value
 * Fields without `data-id` or `data-field-id` are ignored.
 */
export function collectValuesFromContainer(container: Element | null, isAcroFile: boolean = false): SnapshotValues {
  const values: SnapshotValues = {};
  if (!container) return values;

  container.querySelectorAll('input, textarea, select').forEach((el) => {
    let id;
    if(!isAcroFile) {
      id = (el as HTMLElement).getAttribute('data-id');
    } else {
      id =(el as HTMLElement).getAttribute('data-field-id');
    }
    if (!id) return;

    if (el instanceof HTMLInputElement) {
      if (el.type === 'checkbox') {
        values[id] = el.checked ? 'true' : 'false';
      } else if (el.type === 'radio') {
        if (el.checked) values[id] = el.value || 'on';
      } else {
        values[id] = el.value ?? '';
      }
    } else if (el instanceof HTMLTextAreaElement) {
      values[id] = el.value ?? '';
    } else if (el instanceof HTMLSelectElement) {
      values[id] = el.value ?? '';
    }
  });

  return values;
}
